import * as actions from '../Constants/AccountActionTypes';

export const setUserAccount = (payload) => ({ type: actions.SET_USER_ACCOUNT, payload });

export const updateUserAccount = (payload) => ({ type: actions.UPDATE_USER_ACCOUNT, payload })

export const setLeadId = (payload) => ({ type: actions.SET_LEAD_ID, payload });